// components/CoreValues.jsx
import React from 'react';
import '../assets/css/CoreValues.css';

// Import icon images
import IntegrityIcon from '../assets/icons/integrity_icon.png';
import ExcellenceIcon from '../assets/icons/excellence_icon.png';
import InnovationIcon from '../assets/icons/innovation_icon.png';
import PartnershipIcon from '../assets/icons/partnership_icon.png';
import EmpowermentIcon from '../assets/icons/empowerment_icon.png';

const CoreValues = () => {
  const values = [
    {
      title: "Integrity",
      description: "We act with honesty, fairness, and accountability in everything we do.",
      icon: IntegrityIcon
    },
    {
      title: "Excellence",
      description: "We commit to the highest standards in service delivery and talent development.",
      icon: ExcellenceIcon
    },
    {
      title: "Innovation",
      description: "We embrace technology and smart solutions to stay ahead in the evolving outsourcing industry.",
      icon: InnovationIcon
    },
    {
      title: "Partnership",
      description: "We value long-term relationships built on trust, transparency, and shared success.",
      icon: PartnershipIcon
    },
    {
      title: "Empowerment",
      description: "We uplift businesses through reliable support and elevate careers by nurturing Filipino professionals.",
      icon: EmpowermentIcon
    }
  ];

  return (
    <section className="core-values">
      <div className="container">
        <div className="section-header">
          <h2>Our Core Values</h2>
          <p>The principles that guide everything we do</p>
        </div>
        
        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon-container">
                <img src={value.icon} alt={value.title} className="value-icon" />
                <div className="value-number">0{index + 1}</div>
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;